import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import countryCallingCodes from '@functions/countryCallingCodes'

import { useUserForm } from '@hooks/useUser'

interface DetailsProps {
  userForm: ReturnType <typeof useUserForm>,
}

const Details = (props: DetailsProps) => {
  const { userForm } = props

  const {
    entityState: {
      country_calling_code,
      email,
      first_name,
      last_name,
      mobile_number,
    },
    errors,
    handlers,
  } = userForm

  return (
    <DashboardModule title="Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.first_name} label="* First Name">
            <input name="first_name" type="text" value={first_name} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field errorMessage={errors.last_name} label="* Last Name" marginTop={['large', 0]}>
            <input name="last_name" type="text" value={last_name} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.email} label="* Email">
            <input name="email" type="email" value={email} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field boxProps={{ flex: 1 }} label="Mobile" marginTop={['large', 0]}>
            <Box style={{ flexDirection: 'row', marginRight: 'small', width: '100%' }}>
              {/*
               // @ts-expect-error TS2322 */}
              <select
                name="country_calling_code"
                value={country_calling_code}
                {...handlers}
              >
                <option value="">Select...</option>

                {countryCallingCodes.map(({ key, value, title }) => (
                  <option key={key} value={value}>
                    {title}
                  </option>
                ))}
              </select>

              <Form.Field boxProps={{ marginLeft: 'small', width: '70%' }}>
                <input type="text" value={mobile_number} name="mobile_number" {...handlers} />
              </Form.Field>
            </Box>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default Details
